var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMyBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mypage / Bell_Ring"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 17.3394V18.3394C15 19.9962 13.6569 21.3394 12 21.3394C10.3431 21.3394 9 19.9962 9 18.3394V17.3394M15 17.3394H9M15 17.3394H18.5905C18.973 17.3394 19.1652 17.3394 19.3201 17.2871C19.616 17.1873 19.8475 16.955 19.9473 16.6591C19.9997 16.5036 19.9997 16.3108 19.9997 15.9253C19.9997 15.7566 19.9995 15.6722 19.9863 15.5918C19.9614 15.4398 19.9024 15.2957 19.8126 15.1706C19.7651 15.1045 19.7047 15.0441 19.5858 14.9252L19.1963 14.5356C19.0706 14.41 19 14.2395 19 14.0618V10.3394C19 6.47336 15.866 3.33935 12 3.33936C8.13401 3.33936 5 6.47337 5 10.3394V14.0618C5 14.2395 4.92924 14.41 4.80357 14.5356L4.41406 14.9251C4.29477 15.0444 4.23504 15.1044 4.1875 15.1706C4.09766 15.2957 4.03815 15.4398 4.0132 15.5918C4 15.6722 4 15.7566 4 15.9253C4 16.3109 4 16.5036 4.05245 16.6591C4.15225 16.955 4.3848 17.1873 4.68066 17.2871C4.83556 17.3394 5.02701 17.3394 5.40956 17.3394H9M18.0186 2.35303C19.3978 3.39234 20.4843 4.77112 21.1724 6.35509M5.98197 2.35303C4.60275 3.39234 3.5162 4.77112 2.82812 6.35509",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyBell);
export default __webpack_public_path__ + "static/media/ic_my_bell.520f18e501e6564975fba251f41150b1.svg";
export { ForwardRef as ReactComponent };